const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerMyInvestmentsContractsEmptyStates = require('../../brokerMyInvestmentsContractsEmptyStates/brokerMyInvestmentsContractsEmptyStates');
const BrokerMyInvestmentsWrappedContractsTable = require('../../brokerMyInvestmentsWrappedContractsTable/brokerMyInvestmentsWrappedContractsTable');
const BrokerMyInvestmentsStocksTable = require('../../brokerMyInvestmentsStocksTable/brokerMyInvestmentsStocksTable');

// @helpers
const { formatText, FormattedText, formatTextNamed } = require('core/i18n').i18n;

// @constants
const {
    TYPE_STOCKS,
    MYPROFILE_BROKER_EXPLORE
} = require('constants/index');

class brokerMyInvestmentsWrappedStockContractTable extends React.Component {

    buildFooterAndSeeAllLinks(immProducts, contractId) {
        return (
            <div className="broker-my-investments-tables__link-wrapper clearfix">
                {this.buildShowFooterTable()}
                <div className="pull-right">
                    {this.buildSeeAllLink(contractId, immProducts)}
                </div>
            </div>
        );
    }

    buildSeeAllLink(contractId, products) {
        const { showCompleteList, onHandleSeeAllLinkClick } = this.props
        if (showCompleteList[contractId] || products.size <= 5) {
            return;
        }
        const handler = () => {
            onHandleSeeAllLinkClick(contractId);
        };
        return (
            <OKButton modifier="link-complementary" onClick={handler}>
                <FormattedText value="broker-seeAll" />
            </OKButton>
        );
    }

    buildShowFooterTable() {
        return (
            <div className="pull-left my-investments-tables__link">
                <OKLink to={MYPROFILE_BROKER_EXPLORE}>
                    {formatText(`broker-searchByContractLinkText`)}
                </OKLink>
            </div>
        );
    }

    buildShowTable(immProducts, contractId) {
        return (
            <BrokerMyInvestmentsStocksTable
                immStocks={immProducts}
                showCompleteList={this.props.showCompleteList[contractId]}
                type={TYPE_STOCKS}
                isContractSection={true}
                onHandleBuyClick={this.props.onHandleBuyClick}
                pageName={this.props.pageName}
            />
        );
    }

    render() {
        const { immContract, immMyWalletCharts, accountNumber, postWalletAlias, type, immBrokerContractState } = this.props;
        const contractId = immContract.get('contract');
        const key = accountNumber ? accountNumber : contractId;
        const earningsPercentage = immContract.get('profitablePercentage');
        const totalValue = immContract.get('summarizedValor');
        const capital = immContract.get('investmentsCapital');
        const immProducts = immContract.get('elements');
        const interventionType = immProducts.getIn(['0', 'interventionType']);
        const contractName = immContract.get('descripcion') || formatTextNamed(`broker-defaultContractName_${type}`);
        const currency = 'EUR'; // (franco.montenegro) To check
        let earnings = immContract.get('summarizedProfitability');

        const contract = Immutable.fromJS({
            numerodecontrato: immProducts.getIn(['0', 'numerodecontrato']),
            producto: immProducts.getIn(['0', 'producto'])
        });

        //data used here is coming from brokerWallets, as contractForTooltip it's holded in brokerMyInvestments reducer
        //so we neet to concatenate using brokerWallets data.
        const contractForTooltip = immProducts.getIn(['0', 'contractForTooltip']);

        let showTable;
        let footerAndSeeAllLinks;
        if (immProducts && immProducts.size != 0) {
            showTable = this.buildShowTable(immProducts, contractId);
            footerAndSeeAllLinks = this.buildFooterAndSeeAllLinks(immProducts, contractId);
        } else {
            showTable = (
                <BrokerMyInvestmentsContractsEmptyStates
                    immMyWalletCharts={immMyWalletCharts}
                >
                </BrokerMyInvestmentsContractsEmptyStates>
            );
            earnings = 0;
        }

        return (
            <BrokerMyInvestmentsWrappedContractsTable
                size={immProducts.size}
                contract={contract}
                contractName={contractName}
                accountNumber={accountNumber}
                immBrokerContractState={immBrokerContractState}
                currency={currency}
                earnings={earnings}
                earningsPercentage={earningsPercentage}
                capital={capital}
                total={totalValue}
                key={key}
                contractId={contractId}
                postAlias={postWalletAlias}
                interventionType={interventionType}
                contractForTooltip={contractForTooltip}
                setOperationContractValue={this.props.setOperationContractValue}
                setOrdersAndMovementsContract={this.props.setOrdersAndMovementsContract}
                type={type}
                onOpenTraderClick={this.props.onOpenTraderClick}
                pageName={this.props.pageName}
            >
                {showTable}
                {footerAndSeeAllLinks}
            </BrokerMyInvestmentsWrappedContractsTable>
        );
    }
}

brokerMyInvestmentsWrappedStockContractTable.propTypes = {
    immContract: PropTypes.object,
    immBrokerContractState: PropTypes.object,
    state: PropTypes.object,
    accountNumber: PropTypes.number,
    type: PropTypes.string,
    immMyWalletCharts: PropTypes.object,
    postWalletAlias: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    setOperationContractValue: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    onHandleSeeAllLinkClick: PropTypes.func.isRequired,
    showCompleteList: PropTypes.object,
    onHandleBuyClick: PropTypes.func.isRequired,
    pageName: PropTypes.func
};

module.exports = brokerMyInvestmentsWrappedStockContractTable;
